import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.bookingPayment
)

export const selectIsPaymentModalOpen = createSelector(
    baseSelector,
    (state) => state.isPaymentModalOpen
)

export const selectIsCancelBookingModalOpen = createSelector(
    baseSelector,
    (state) => state.isCancelBookingModalOpen
)

export const selectTicketsModalOpen = createSelector(
    baseSelector,
    (state) => state.isTicketsModalOpen
)

export const selectIsAcknowledgeModalOpen = createSelector(
    baseSelector,
    (state) => state.isAcknowledgeModalOpen
)

export const selectOnPayment = createSelector(
    baseSelector,
    (state) => state.onPayment
)

export const selectOnCancel = createSelector(
    baseSelector,
    (state) => state.onCancel
)

export const selectOnAcknowledge = createSelector(
    baseSelector,
    (state) => state.onAcknowledge
)

export const selectBooking = createSelector(
    baseSelector,
    (state) => state.booking
)